/* eslint-disable max-classes-per-file */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import {
  Redirect, Route, Switch, withRouter,
} from 'react-router-dom';
import '../../assets/dsgov/css/dsgov-base.css';
import Header from '../../components/Header/Header';
import ContextUser from '../../context/UserContext';
import Auth from '../Auth/Auth';
import ConversationFlow from '../ConversationFlow/ConversationFlow';
import ChatbotTesting from '../ChatbotTesting/ChatbotTesting';
import Home from '../Home/Home';
import './Layout.css';
import { Navigation } from './Navigation';
import { KnowledgeBases } from '../KnowledgeBases/KnowledgeBases';

/**
 * Container do Layout do App
 */
export class Layout extends Component {
  constructor() {
    super();
    this.state = {
      breadcrumbs: null,
      selectedBotId: null,
    };
  }

  /* Se a url for '/bot', desmarca o bot selecionado, caso exista
  para encaminhar o redirecionamento */
  componentDidUpdate() {
    const pathName = this.props.location.pathname;
    if (pathName === '/bots'
      && this.state.selectedBotId) {
      this.setState({ selectedBotId: null });
    }
  }

  setBreadscrumbs = (breadcrumbs) => {
    this.setState({ breadcrumbs });
  }

  render() {
    const pathName = this.props.location.pathname;

    if (pathName === '/logout') {
      this.props.userContext.setUser(null);
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = `${window.location.origin}/curadoria`;
    }

    if (!this.props.userContext.user) {
      /* Se não existir usuario no contexto,
     redireciona para autenticação */
      if (pathName !== '/') this.props.history.push('/');
      return <Auth history={this.props.history} />;
    }

    return (
      <div>
        <Header selectedBotId={this.state.selectedBotId} />
        <main>
          <div className="container-xl" style={{ height: '100%' }}>
            <Navigation
              show={this.props.location.pathname.match(/^\/bots\/(fluxos-conversa|teste|metrica|knowledgebases)/g)}
              breadcrumbs={this.state.breadcrumbs}
            />
            <Switch>
              <Route
                path="/bots/fluxos-conversa"
                exact
              >
                <ConversationFlow
                  activeBotId={this.state.selectedBotId}
                  setBreadscrumbs={this.setBreadscrumbs}
                />
              </Route>
              <Route
                path="/bots/testes"
                exact
              >
                <ChatbotTesting
                  setBreadscrumbs={this.setBreadscrumbs}
                />
              </Route>
              <Route
                path="/bots/knowledgebases"
                exact
              >
                <KnowledgeBases
                  setBreadscrumbs={this.setBreadscrumbs}
                />
              </Route>              
              <Route
                path="/bots"
                exact
              >
                <Home
                  selectBot={(botId) => {
                    window.scrollTo(0, 0);
                    this.setState({ selectedBotId: botId });
                    this.props.history.push('/bots/fluxos-conversa');
                  }}
                />
              </Route>
              <Redirect to="/bots" />
            </Switch>
          </div>
        </main>
      </div>
    );
  }
}

/**
 Wrapper que injeta o
 contexto nos props do componente
  */
class LayoutWraper extends Component {
  render() {
    return (
      <ContextUser.Consumer>
        {(context) => (
          <Layout userContext={context} {...this.props} />
        )}
      </ContextUser.Consumer>
    );
  }
}

export default withRouter(LayoutWraper);
